import { VideoPuzzleFileType } from '../type/VideoPuzzleFileType';

export const ExpectedVideoPuzzleOriginalFile: VideoPuzzleFileType[] = [
  {
    accept: 'video/mp4',
    name: 'original',
    saveAsType: 'video/mp4',
    quality: 1,
    label: 'Original',
  },
];

export const ExpectedVideoPuzzleFiles: VideoPuzzleFileType[] = [
  {
    accept: 'image/jpeg,image/jpg',
    name: 'icon',
    saveAsType: 'image/jpeg',
    quality: 0.9,
    label: 'Icon',
    width: 256, // in px
    height: 256, // in px
  },
  {
    accept: 'image/jpeg,image/jpg',
    name: 'previewPlaceholder',
    saveAsType: 'image/jpeg',
    quality: 0.9,
    label: 'Preview Placeholder',
    width: 1024, // in px
    height: 1024, // in px
  },
  {
    accept: 'image/webp',
    name: 'iconAnimated',
    saveAsType: 'image/webp',
    quality: 0.9,
    label: 'Animated Icon',
    width: 256, // in px
    height: 256, // in px
  },
  {
    accept: 'video/mp4',
    name: 'original',
    saveAsType: 'video/mp4',
    quality: 1,
    label: 'Original',
  },
  {
    accept: 'video/mp4',
    name: 'previewVideo',
    saveAsType: 'video/mp4',
    quality: 1,
    label: 'Preview Video',
    width: 1024, // in px
    height: 1024, // in px
  },
];
